import type { SponsoredAirlineV2LoadedAction } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { SponsoredAirlineV2 } from '@web-platform/shared-universal-types/src/redux/state/entities/sponsoredAirlineV2';

export const SPONSORED_AIRLINE_V2_LOADED = 'SPONSORED_AIRLINE_V2_LOADED';

export function sponsoredAirlineV2Loaded(
  sponsoredAirlineV2: SponsoredAirlineV2,
): SponsoredAirlineV2LoadedAction {
  return {
    type: SPONSORED_AIRLINE_V2_LOADED,
    payload: { sponsoredAirlineV2 },
  };
}
